export default __webpack_public_path__ + "static/media/loader.fb48bb52.png";